import { Customer } from '../customer.model';
import { VisitStatus } from '../enums/visit-status.enum';
import { ExportControlPost } from '../export-control/export-control-post.model';

export interface IVisitRequest {
  id: string;
  userId: string;
  startDate: string;
  endDate: string;
  trainingId: string;
  trainingCenterId: string;
  firstName: string;
  lastName: string;
  middleName?: string;
  dateOfBirth: string;
  hotelName?: string;
  hotelPhone?: string;
  phone?: string;
  email?: string;
  emailConsentDate?: string;
  contactName?: string;
  identityPolicyConsentDate?: string;
  badgeNumber?: string;
  visitReason?: string;
  hostName?: string;
  lastStatusChange?: string;
  isBadgeActivated?: boolean;
  exportControl?: ExportControlPost;
  customer?: Customer;
  checkinStatus?: VisitStatus;
}

export class VisitRequest implements IVisitRequest {
  id: string;
  userId: string;
  startDate: string;
  endDate: string;
  trainingId: string;
  trainingCenterId: string;
  firstName: string;
  lastName: string;
  middleName?: string;
  dateOfBirth: string;
  hotelName?: string;
  hotelPhone?: string;
  phone: string;
  email?: string;
  emailConsentDate?: string;
  contactName?: string;
  identityPolicyConsentDate?: string;
  badgeNumber?: string;
  visitReason?: string;
  hostName?: string;
  lastStatusChange?: string;
  isBadgeActivated?: boolean;
  exportControl: ExportControlPost;
  customer?: Customer;
  checkinStatus: VisitStatus;

  constructor(clone: VisitRequest = null) {
    this.id = '';
    this.userId = '';
    this.startDate = '';
    this.endDate = '';
    this.trainingId = '';
    this.trainingCenterId = '';
    this.firstName = '';
    this.lastName = '';
    this.middleName = '';
    this.dateOfBirth = '';
    this.hotelName = '';
    this.hotelPhone = '';
    this.phone = '';
    this.email = '';
    this.emailConsentDate = '';
    this.contactName = '';
    this.identityPolicyConsentDate = '';
    this.badgeNumber = '';
    this.visitReason = '';
    this.hostName = '';
    this.lastStatusChange = '';
    this.isBadgeActivated = false;
    this.exportControl = new ExportControlPost();
    this.customer = new Customer();
    this.checkinStatus = VisitStatus.CHECKIN_IN_PROGRESS;

    if (clone) {
      this.id = clone.id;
      this.userId = clone.userId;
      this.startDate = clone.startDate;
      this.endDate = clone.endDate;
      this.trainingId = clone.trainingId;
      this.trainingCenterId = clone.trainingCenterId;
      this.firstName = clone.firstName;
      this.lastName = clone.lastName;
      this.middleName = clone.middleName;
      this.dateOfBirth = clone.dateOfBirth;
      this.hotelName = clone.hotelName;
      this.hotelPhone = clone.hotelPhone;
      this.phone = clone.phone;
      this.email = clone.email;
      this.emailConsentDate = clone.emailConsentDate;
      this.contactName = clone.contactName;
      this.identityPolicyConsentDate = clone.identityPolicyConsentDate;
      this.badgeNumber = clone.badgeNumber;
      this.visitReason = clone.visitReason;
      this.hostName = clone.hostName;
      this.lastStatusChange = clone.lastStatusChange;
      this.isBadgeActivated = clone.isBadgeActivated;
      this.customer = new Customer(clone.customer);
      this.checkinStatus = clone.checkinStatus;
      this.exportControl = clone.exportControl;
    }
  }
}
